$( document ).ready(function() {
function cartCount(){$.getJSON("/cart.js",function(t){t.item_count>=100?$("span[data-js-cart-count]").text("99+"):$("span[data-js-cart-count]").text(t.item_count)})}function openDrawer(t){$.ajax({type:"GET",url:"/",dataType:"html",success:function(t){cartCount();var a=$(t).find(".quick-cart__container").html();$(".quick-cart__container").html(a),$(".quick-cart").addClass("animation--quick-cart-revealed"),$(".quick-cart .quick-cart__wrapper").addClass("active")}})}function addItemToCart(t,a,n,c){data={id:t,quantity:a,properties:{shipping_interval_frequency:n,shipping_interval_unit_type:c}},jQuery.ajax({type:"POST",url:"/cart/add.js",data:data,dataType:"json",success:function(){openDrawer()}})}
  $('.logos_items1').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll:1,
    responsive: [
    {
      breakpoint: 720,
      settings: {
         slidesToShow: 2,
      }
    }
   ]
  });


  var proinfo = document.getElementsByClassName("multi-slide");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }

setTimeout(function () {
  var proinfo = document.getElementsByClassName("product-item");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }
}, 2000);

  setTimeout(function () {
  var proinfo = document.getElementsByClassName("gallery-item");
  var hei = 0;
  for(var i=0; i< proinfo.length; i++){
    var heigh = proinfo[i].offsetHeight;
    if(heigh > hei){
      hei = heigh;
    }
  }
  for(var i=0; i< proinfo.length; i++){
    proinfo[i].style.height = hei +"px";
  }
}, 2000);

if($('body').hasClass('template-product')){
  $('.product__meta form.product-form .product-form__controls-group--submit button[data-add-to-cart]').on('click', function(e){
     if($('#rc_container').find('.rc_block__type__autodeliver').hasClass('rc_block__type--active')){
       e.preventDefault();
       console.log('inin');
       var selling_id = $('#rc_container').find('select#rc_duplicate_selector').val();
       var frequency =  $('#rc_container').find('#rc_autodeliver_options select[name="properties[shipping_interval_frequency]"]').val();
       var unit_type =  $('#rc_container').find('input[name="properties[shipping_interval_unit_type]"]').val();
      
       addItemToCart(selling_id, 1, frequency, unit_type);
       // addItemToCart(949931647, 1, "1", "Months")
       return false;
     }

    // setTimeout(() => {
    // jQuery.getJSON('/cart.js', function (cart, textStatus) {
    //   var total_price = cart.total_price;
    //   var free_gift_value = $("body").attr("data-free_gift");
    //   var free_gift_id = $("body").attr("data-free_product");
    //   var data = { updates: {} };
    //   if ((total_price >= free_gift_value)) {
    //     data.updates[free_gift_id] = 1;
    //   }
    //   else
    //   {
    //     data.updates[free_gift_id] = 0;
    //   }
    //   var params = {
    //     type: 'POST',
    //     url: '/cart/update.js',
    //     // data: { updates: cartUpdates },
    //     data: data,
    //     dataType: 'json',
    //     success: function(stuff) {
    //     document.dispatchEvent(new CustomEvent('quick-cart:refresh'));
    //     // document.dispatchEvent(new CustomEvent('quick-cart:refresh'));
    //     }
    //   };
    //   $.ajax(params);
    // });
    // }, 1500);
  });
   var isALARendered;
    function ALAcheck() {
      isALARendered = setInterval(function () {
        customALA()
      }, 200);
    }
    ALAcheck();
    function customALA() {
    var selector = $('.cbb-also-bought-container');
      if(selector.length > 0) {
        clearInterval(isALARendered);        
       $(selector).addClass('section');
      }  
    }

 
  
   var isALARendered_highlight;
    function ALAcheck_highlight() {
      isALARendered_highlight = setInterval(function () {
        customALA_highlight()
      }, 200);
    }
    ALAcheck_highlight();
    function customALA_highlight() {
    var selector = $('.heyLight-inline');
      if(selector.length > 0) {
        clearInterval(isALARendered_highlight);        
          var u = "https://get.geojs.io/v1/ip/country.json";
          getDetails(u).then(function(data) {            
            // console.log(data.country);
            if(data.country != "CH"){
              $('.heidi_messaging').css('display','none');
            }else{
              $('.heidi_messaging').css('display','block');
            }
          })
      }  
    }
}

   //get country
  function getDetails(u) {
      return fetch(u)
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json(); // Assuming the response is in JSON format
          })
          .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
          });
  }
  
  //cart page
  if($('body').hasClass('template-cart')){
    var isALARendered_highlight;
    function ALAcheck_highlight() {
      isALARendered_highlight = setInterval(function () {
        customALA_highlight()
      }, 200);
    }
    ALAcheck_highlight();
    function customALA_highlight() {
    var selector = $('.heyLight-inline');
      if(selector.length > 0) {
        clearInterval(isALARendered_highlight);        
          var u = "https://get.geojs.io/v1/ip/country.json";
          getDetails(u).then(function(data) {            
            // console.log(data.country);
            if(data.country != "CH"){
              $('.heidi_messaging').css('display','none');
            }else{
              $('.heidi_messaging').css('display','block');
            }
          })
      }  
    }
  }

  
});